export const EMPTY_DOC_CONTENT_SIZE = 2;
